import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Link } from "react-router-dom";
import { getremoteInquirydataApi, getsingleprescription, getsinglebuildsheetData, getsinglestagestation, getsinglebuilstation, getsingleshipstagestation } from "../../Api/iron"
import { proscriptionhistory, getPrescription } from "../../Api/prescriptionApis"
import TabFormData from "../DashboardComponents/TabsData/TabFormData";
import TabNotesData from "../DashboardComponents/TabsData/TabNotesData";
import AccordionData from "../../DashboardPages/clubfittingupdate/AccordionData";
import { FaAngleUp, FaStar } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import PrescriptionLeft from "../Prescription/PrescriptionLeft";
import BuildAccordion from "./BuildAccordion";
import BuildSheetLeft from "./BuildSheetLeft";
import BuildStation from "./BuildStation";
import BuildStationLeft from "./BuildStationLeft";
import { getInventoryByType, getModeldatabymake } from "../../Api/inventoryApi";

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};


const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};


const initialPrescriptionStateNew = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',

    bounceselect: '',
    lieageselect: '',
    shaftweightselect: '',
    shaftflexselect: '',
    shaftprofileselect: '',
    gripSizeselect: '',
    clubLengthselect: '',
    swingWeightselect: '',
};

function BuildTabBuildStation({ project_id, project_step = "history", currentpagename, buildsheets, ondeleteChange, allmodels, dropdowndata, BuildStations, dropdowndata2, buildsheetnumber, allMakeData, prescriptioncalc, SinglePrescription, remortFittingFormData, BuildStation }) {

    const [validated, setValidated] = useState(false);
    const [historydata, setHistorydata] = useState([]);
    const [formData, setFormData] = useState(initData);
    const [prescription, setPrescription] = useState(0);
    const [buildsheetData, setBuildsheetData] = useState(0);

    const [current_project_step, setCurrent_project_step] = useState(project_step);
    const [prescriptiondata, setPrescriptiondata] = useState(initialPrescriptionState);


    const [prescriptionNew, setPrescriptionNew] = useState(initialPrescriptionStateNew);

    const [optimalHeads, setOptimalHeads] = useState(0);
    const [optimalShafts, setOptimalShafts] = useState(0);
    const [optimalGrips, setOptimalGrips] = useState(0);

    const [makedata, setMakeData] = useState([]);
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);


    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');

    const getDataById = () => {

        if (remortFittingFormData) {
            setFormData(remortFittingFormData);
            setPrescriptionNew(remortFittingFormData?.fittingdata)
        }

    }

    const [resultoutput, setResultoutput] = useState({
        white: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        black: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        blue: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        pink: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        purple: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        red: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        orange: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        green: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
    });

    const getbuildsheetscript = () => {
        // getPrescription({ project_id: project_id }).then((res) => {
        //     if (!res.data.status) {
        //         // setErrors(res.data.data);
        //     } else {
        //         setPrescriptiondata(res.data.data);
        //         setOptimalHeads(parseInt(res.data.data.optimalHeadsStar));
        //         setOptimalShafts(parseInt(res.data.data.optimalShaftsStar));
        //         setOptimalGrips(parseInt(res.data.data.optimalGripsStar));
        //         setbrandsData(res.data.data);
        //     }

        // }).catch((error) => {
        //     console.log("error", error);
        // });
        if (prescriptioncalc) {
            setPrescriptiondata(prescriptioncalc);
            setOptimalHeads(parseInt(prescriptioncalc.optimalHeadsStar));
            setOptimalShafts(parseInt(prescriptioncalc.optimalShaftsStar));
            setOptimalGrips(parseInt(prescriptioncalc.optimalGripsStar));
            // setbrandsData(prescriptioncalc);
        }
    }

    const [allmodelsdata, setAllmodelsdata] = useState([]);

    useEffect(() => {
        if (allmodels && allmodels.length > 0 && allmodelsdata && allmodelsdata.length === 0) {
            setAllmodelsdata(allmodels);
        }
    }, [allmodels]);

    const getData = () => {

        switch (current_project_step) {
            case "history":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "prescription":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "buildsheet":
                getbuildsheetscript();
                getmakedata(0);
                getDataById();
                break;
            case "stagestation":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "buildstation":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            case "shipstation":
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
            default:
                getDataById();
                getprescriptionDataById();
                getmakedata(0);
                break;
        }
    }

    const getprescriptionDataById = () => {
        // getsingleprescription({ project_id: project_id }).then((res) => {
        //     if (res?.code === 200) {
        //         const prescriptionData = res.data.data;
        //         setPrescription(prescriptionData);
        //     } else {
        //         // alert(res.data?.message);
        //         console.log(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })
        if (SinglePrescription) {
            setPrescription(SinglePrescription);
        }
    }

    const getbuildsheetDataById = () => {
        getsinglebuildsheetData({ project_id: project_id }).then((res) => {
            if (res?.code === 200) {
                const buildsheetData = res.data.data;
                setBuildsheetData(buildsheetData);
            } else {
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        getData();
    }, [project_id])


    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        const filtermakedata = allMakeData && allMakeData.filter((item) => item.item_type_id.includes(id));
        if (id === 4) {
            setMakeData(filtermakedata);
        }
        if (id === 7) {
            setShaftData(filtermakedata);
        }
        if (id === 8) {
            setGripData(filtermakedata);
        }
    }


    const [isTabVisible, setIsTabVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 991) {
                setIsTabVisible(true);
            } else {
                setIsTabVisible(false);
            }
        };

        // Set the initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const [dropdowndataShipping, setDropdowndataShipping] = useState([]);
    const [dropdowndatabuilder, setDropdowndatabuilder] = useState([]);

    useEffect(() => {
        if (dropdowndata) {
            setDropdowndataShipping(dropdowndata);
        }
    }, [dropdowndata]);

    useEffect(() => {
        if (dropdowndata2) {
            setDropdowndatabuilder(dropdowndata2);
        }
    }, [dropdowndata2]);



    const getselectbounce = (category, value) => {
        const selectedValue = parseInt(value);

        // Define options for each category
        const options = {
            bounce: {
                1: 'Low Bounce',
                2: 'Mid Bounce',
                3: 'High Bounce'
            },
            lieAngle: {
                1: 'Upright',
                2: 'Standard',
                3: 'Flat'
            },
            shaftWeight: {
                1: 'Heavy',
                2: 'Medium',
                3: 'Light'
            },
            shaftFlex: {
                1: 'Hard',
                2: 'Medium',
                3: 'Soft'
            },
            shaftProfile: {
                1: 'Firm Tip',
                2: 'Soft Mid',
                3: 'Firm Butt'
            },
            gripSize: {
                1: 'Oversize',
                2: 'Mid',
                3: 'Standard'
            },
            clubLength: {
                1: 'Long',
                2: 'Medium',
                3: 'Short'
            },
            swingWeight: {
                1: 'Heavy',
                2: 'Medium',
                3: 'Light'
            }
        };

        // Return the option label based on category and selected value
        return options[category]?.[selectedValue] || `Select ${category.replace(/([A-Z])/g, ' $1').trim()}`;
    };


    useEffect(() => {
        if (allMakeData.length > 0) {
            getmakedata(4);
            getmakedata(7);
            getmakedata(8);
        }
    }, [allMakeData]);

    const handleNestedChange = (section, option, subField, value) => {

        if (allmodelsdata.length > 0) {
            console.log("allmodelsdata", allmodelsdata);
            const optionKey = `option${option}`;
            let type_id = "";
            switch (section) {
                case "optimalHeads":
                    type_id = "4";
                    break;
                case "optimalShafts":
                    type_id = "7";
                    break;
                case "optimalGrips":
                    type_id = "8";
                    break;
                default:
                    break;
            }

            // Filter the models from allmodels array
            const filteredModels = allmodelsdata.filter(model =>
                model.Make === value && model.type_id === type_id
            );


            // Set the data based on section, subField, and option
            if (filteredModels.length > 0) {
                const data = filteredModels;

                if (section === 'optimalHeads') {
                    switch (option) {
                        case 1:
                            console.log('head 1', data);
                            setHead1(data);
                            break;
                        case 2:
                            setHead2(data);
                            break;
                        case 3:
                            setHead3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalShafts') {
                    switch (option) {
                        case 1:
                            setShaft1(data);
                            break;
                        case 2:
                            setShaft2(data);
                            break;
                        case 3:
                            setShaft3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalGrips') {
                    switch (option) {
                        case 1:
                            setGrip1(data);
                            break;
                        case 2:
                            setGrip2(data);
                            break;
                        case 3:
                            setGrip3(data);
                            break;
                        default:
                            break;
                    }
                }

                const updateData = (setFunction, currentData) => {
                    setFunction(prevData => ({
                        ...prevData,
                        [optionKey]: { // Update the correct option (option1, option2, option3)
                            ...prevData[optionKey],
                            [subField]: value // Update the specific field (make or model)
                        }
                    }));
                };

                // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
                if (section === 'optimalHeads') {
                    updateData(setOptimalHeadsobject, optimalHeadsobject);
                } else if (section === 'optimalShafts') {
                    updateData(setOptimalShaftsobject, optimalShaftsobject);
                } else if (section === 'optimalGrips') {
                    updateData(setOptimalGripsobject, optimalGripsobject);
                }
            } else {
                console.log("");
            }
        }
    };


    useEffect(() => {
        if (allmodelsdata.length > 0) {
            handleNestedChange('optimalHeads', 1, 'make', remortFittingFormData?.optimalHeads?.option1?.make);
            handleNestedChange('optimalHeads', 2, 'make', remortFittingFormData?.optimalHeads?.option2?.make);
            handleNestedChange('optimalHeads', 3, 'make', remortFittingFormData?.optimalHeads?.option3?.make);

            handleNestedChange('optimalShafts', 1, 'make', remortFittingFormData?.optimalShafts?.option1?.make);
            handleNestedChange('optimalShafts', 2, 'make', remortFittingFormData?.optimalShafts?.option2?.make);
            handleNestedChange('optimalShafts', 3, 'make', remortFittingFormData?.optimalShafts?.option3?.make);

            handleNestedChange('optimalGrips', 1, 'make', remortFittingFormData?.optimalGrips?.option1?.make);
            handleNestedChange('optimalGrips', 2, 'make', remortFittingFormData?.optimalGrips?.option2?.make);
            handleNestedChange('optimalGrips', 3, 'make', remortFittingFormData?.optimalGrips?.option3?.make);
        }

    }, [allmodelsdata]);


    const [optimalHeadsobject, setOptimalHeadsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalShaftsobject, setOptimalShaftsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalGripsobject, setOptimalGripsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });


    useEffect(() => {
        if (remortFittingFormData?.optimalHeads) {
            setOptimalHeadsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...remortFittingFormData.optimalHeads // Update with new data
            }));

            setOptimalHeads(Number(remortFittingFormData?.optimalHeadsStar));
        }

        if (remortFittingFormData?.optimalShafts) {
            setOptimalShaftsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalShafts
            }));

            setOptimalShafts(Number(remortFittingFormData?.optimalShaftsStar));
        }

        if (remortFittingFormData?.optimalGrips) {
            setOptimalGripsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalGrips
            }));
            setOptimalGrips(Number(remortFittingFormData?.optimalGripsStar));
        }

        //also check 
    }, [remortFittingFormData]);


    return (
        <>
            <div className="tab-container tab-club-fitting">
                <Tabs
                    defaultActiveKey="buildstation"
                    id="uncontrolled-tab-example"
                    className="club-fitting-tab new_mobile_tab tab-wrapper"
                >
                    <Tab eventKey="buildstation" title="Build">
                        <BuildStationLeft buildsheetdataa={buildsheets} allmodels={allmodels} dropdowndataShipping={dropdowndataShipping} BuildStationsss={BuildStations} dropdowndatabuilder={dropdowndatabuilder} buildsheets={buildsheetnumber} BuildStationdata={BuildStation} remortFittingFormData={remortFittingFormData}/>
                    </Tab>

                    {
                        formData?.type === "0" && (
                            <Tab eventKey="script" title="Script">
                                <div className="tab-box-section mb-4">
                                    <div className="accordion-section">
                                        <Accordion defaultActiveKey="0">
                                            <Accordion.Item eventKey="0" className="results-accordion">
                                                <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                    <div className="accordion_card_view" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text text-left">
                                                                    <h5>
                                                                        <span className="color"></span>
                                                                        <div className="d-flex align-items-center gap-1">Bounce: <div className="light-text ms-1">{getselectbounce("bounce", prescriptionNew?.bouncedropdownselect)}</div></div>
                                                                    </h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon ">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="results-accordion-body">
                                                        <textarea className="dashboard-text-area" value={prescriptionNew?.bounce} style={{ color: '#ffffff', pointerEvents: 'none' }} rows="3" placeholder="Enter your script here"></textarea>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1" className="results-accordion black">
                                                <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                    <div className="accordion_card_view" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text text-left">
                                                                    <h5>
                                                                        <span className="color"></span>
                                                                        <div className="d-flex align-items-center gap-1">Lie Angle:  <div className="light-text ms-1">{getselectbounce("lieAngle", prescriptionNew?.lieagedropdownselect)}</div></div>
                                                                    </h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon ">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="results-accordion-body">
                                                        <textarea className="dashboard-text-area" value={prescriptionNew?.lieage} style={{ color: '#ffffff', pointerEvents: 'none' }} rows="3" placeholder="Enter your script here"></textarea>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="2" className="results-accordion blue">
                                                <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                    <div className="accordion_card_view" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text text-left">
                                                                    <h5>
                                                                        <span className="color"></span>
                                                                        <div className="d-flex align-items-center gap-1">Shaft Weight: <div className="light-text ms-1">{getselectbounce("shaftWeight", prescriptionNew?.shaftweightdropdownselect)}</div></div>
                                                                    </h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon ">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="results-accordion-body">
                                                        <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.shaftweight} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="3" className="results-accordion pink">
                                                <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                    <div className="accordion_card_view" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text text-left">
                                                                    <h5>
                                                                        <span className="color"></span>
                                                                        <div className="d-flex align-items-center gap-1">Shaft Flex:  <div className="light-text ms-1">{getselectbounce("shaftFlex", prescriptionNew?.shaftflexdropdownselect)}</div></div>
                                                                    </h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon ">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="results-accordion-body">
                                                        <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.shaftflex} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="5" className="results-accordion red">
                                                <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                    <div className="accordion_card_view" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text text-left">
                                                                    <h5>
                                                                        <span className="color"></span>
                                                                        <div className="d-flex align-items-center gap-1">Grip Size:  <div className="light-text ms-1">{getselectbounce("gripSize", prescriptionNew?.gripSizedropdownselect)}</div></div>
                                                                    </h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon ">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="results-accordion-body">
                                                        <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.gripSize} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="6" className="results-accordion orange">
                                                <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                    <div className="accordion_card_view" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text text-left">
                                                                    <h5>
                                                                        <span className="color"></span>
                                                                        <div className="d-flex align-items-center gap-1">Club Length:  <div className="light-text ms-1">{getselectbounce("clubLength", prescriptionNew?.clubLengthdropdownselect)}</div></div>
                                                                    </h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon ">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="results-accordion-body">
                                                        <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.clubLength} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="7" className="results-accordion green">
                                                <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                    <div className="accordion_card_view" id="lesson_card_1">
                                                        <Accordion.Header>
                                                            <div className="gab_title">
                                                                <div className="gab_text text-left">
                                                                    <h5>
                                                                        <span className="color"></span>
                                                                        <div className="d-flex align-items-center gap-1">Swing Weight:  <div className="light-text ms-1">{getselectbounce("swingWeight", prescriptionNew?.swingWeightdropdownselect)}</div></div>
                                                                    </h5>
                                                                </div>
                                                                <div className="collapsed">
                                                                    <div className="gab_icon ">
                                                                        <FaAngleUp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Accordion.Header>
                                                    </div>
                                                    <Accordion.Body className="results-accordion-body">
                                                        <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.swingWeight} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                    </Accordion.Body>
                                                </div>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                                <div className="tab-box-section mb-4">
                                    <div className="">
                                        <div className="club-fitting-card black_box">
                                        </div>
                                        <div className="form-group prescription-note presc-tab2">
                                            <div className="row mb-3">
                                                {optimalHeads === 1 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                </svg>
                                                            </label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalHeadsobject?.option1?.make} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                    <option value="" disabled>Make</option>
                                                                    {makedata && makedata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalHeadsobject?.option1?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                    <option value="" disabled>Model</option>
                                                                    {head1 && head1.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {optimalHeads === 2 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                </svg>
                                                            </label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalHeadsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalHeads', 2, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                    <option value="" disabled>Make</option>
                                                                    {makedata && makedata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalHeadsobject?.option2?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                    <option value="" disabled>Model</option>
                                                                    {head2 && head2.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {optimalHeads === 3 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                </svg>
                                                            </label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalHeadsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalHeads', 3, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                    <option value="" disabled>Make</option>
                                                                    {makedata && makedata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalHeadsobject?.option3?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                    <option value="" disabled>Model</option>
                                                                    {head3 && head3.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {optimalShafts === 1 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }} >
                                                                <svg stroke="currentColor" fill={`${optimalShafts === 1 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                            </label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalShaftsobject?.option1?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Make</option>
                                                                    {shaftdata && shaftdata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalShaftsobject?.option1?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Model</option>
                                                                    {Shaft1 && Shaft1.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {optimalShafts === 2 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2 " style={{ marginTop: '10px', marginRight: '-30px' }} >
                                                                <svg stroke="currentColor" fill={`${optimalShafts === 2 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                            </label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalShaftsobject?.option2?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Make</option>
                                                                    {shaftdata && shaftdata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalShaftsobject?.option2?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Model</option>
                                                                    {Shaft2 && Shaft2.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {optimalShafts === 3 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2"
                                                                style={{ marginTop: '10px', marginRight: '-30px' }}
                                                            ><svg stroke="currentColor" fill={`${optimalShafts === 3 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalShaftsobject?.option3?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Make</option>
                                                                    {shaftdata && shaftdata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalShaftsobject?.option3?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Model</option>
                                                                    {Shaft3 && Shaft3.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {optimalGrips === 1 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2"
                                                                style={{ marginTop: '10px', marginRight: '-30px' }}
                                                            ><svg stroke="currentColor" fill={`${optimalGrips === 1 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalGripsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalGrips', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Make</option>
                                                                    {gripdata && gripdata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalGripsobject?.option1?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Model</option>
                                                                    {Grip1 && Grip1.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {optimalGrips === 2 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2"
                                                                style={{ marginTop: '10px', marginRight: '-30px' }}
                                                            ><svg stroke="currentColor" fill={`${optimalGrips === 2 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalGripsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalGrips', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Make</option>
                                                                    {gripdata && gripdata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalGripsobject?.option2?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Model</option>
                                                                    {Grip2 && Grip2.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {optimalGrips === 3 && (
                                                    <>
                                                        <div className="row mb-3 align-items-center">
                                                            <label className="col-2 col-sm-2"
                                                                style={{ marginTop: '10px', marginRight: '-30px' }}
                                                            ><svg stroke="currentColor" fill={`${optimalGrips === 3 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalGripsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalGrips', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Make</option>
                                                                    {gripdata && gripdata.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-5 col-sm-5 mb-3">
                                                                <select disabled value={optimalGripsobject?.option3?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                    <option value="" disabled>Model</option>
                                                                    {Grip3 && Grip3.map((item) => (
                                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                        )}

                    <Tab eventKey="client" title="Client">
                        <div className="tab-box-section">
                            <TabFormData project_id={project_id} remortFittingFormData={remortFittingFormData} />
                        </div>
                    </Tab>

                    <Tab eventKey="notes" title="Notes">
                        <TabNotesData project_id={project_id} />
                    </Tab>
                </Tabs>
            </div>
        </>
    );
}

export default BuildTabBuildStation;